module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.letterObject) ? _c('div', {
    staticClass: "brand-review-wrapper"
  }, [_c('div', {
    staticClass: "box brand-review",
    class: _vm.isNew ? 'new-brand-review' : ''
  }, [(!_vm.isNew) ? _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRecommendationLetter(_vm.letterObject.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Заголовок"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.letterObject.title),
      callback: function($$v) {
        _vm.$set(_vm.letterObject, "title", $$v)
      },
      expression: "letterObject.title"
    }
  })], 1), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.letterObject.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.letterObject, "isHidden", $$v)
      },
      expression: "letterObject.isHidden"
    }
  }, [_vm._v("Скрыть с сайта")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.letterObject.file || _vm.file) ? _c('div', {
    staticClass: "link-wrapper"
  }, [_c('a', {
    staticClass: "link mt-10",
    attrs: {
      "href": '/' + _vm.letterObject.file,
      "target": "_blank"
    }
  }, [_vm._v("Просмотреть файл")]), _vm._v(" "), _c('span', {
    staticClass: "delete-file",
    on: {
      "click": _vm.deleteFile
    }
  }, [_vm._v("x")])]) : _c('b-field', {
    staticClass: "mt-10"
  }, [_c('button', {
    staticClass: "button mt-10",
    on: {
      "click": function($event) {
        return _vm.$refs.loadFile.click()
      }
    }
  }, [_vm._v("\n        Загрузить файл\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    ref: "loadFile",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.loadFile
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary mt-10 save-button",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44403d02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/RecommendationLetterItem.vue
// module id = 939
// module chunks = 0